
// import  { useRef } from "react";
// import { Radar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   RadialLinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend,
// } from "chart.js";
 
// ChartJS.register(
//   RadialLinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend
// );
 
// const RadarChartForConversion = ({ data = [] }) => {
//   const chartRef = useRef(null);
 
  
//   const trimmedData = data;
 
//   // Axis labels as "1" to "8"
//   const labels = Array.from({ length: trimmedData.length }, (_, i) =>
//     (i + 1).toString()
//   );
 
//   // Actual values for the polygon
//   const jobCounts = trimmedData.map((item) => item.jobs);
 
//   const datasets = [
//     {
//       label: "Conversion Jobs",
//       data: jobCounts,
//       backgroundColor: "rgba(54, 162, 235, 0.2)",
//       borderColor: "rgba(54, 162, 235, 1)",
//       fill: true,
//       borderWidth: 2,
//       pointRadius: 3,
//     },
//   ];
 
//   const chartData = { labels, datasets };
 
//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         backgroundColor: "#E0B8FF",
//         titleColor: "#212121",
//         bodyColor: "#212121",
//         callbacks: {
//           label: function (context) {
//             return `Jobs: ${context.raw}`;
//           },
//           title: function (context) {
//             const index = context[0].dataIndex;
//             const item = trimmedData[index];
//             // return `${item.source} ➜ ${item.target}`;
//             return item.target
//   ? `${item.source} ➜ ${item.target}`
//   : `${item.source}`;

//           },
//         },
//       },
//     },
//     scales: {
//       r: {
//         angleLines: { color: "#ddd" },
//         grid: { color: "#eee" },
//         suggestedMin: 0,
//         suggestedMax: Math.max(...jobCounts) + 10,
//         ticks: { display: false },
//         pointLabels: {
//           font: { size: 10 },
//           color: "#333",
//         },
//       },
//     },
//   };
 
//   return (
//     <div className="radar-chart-wrapper" style={{ width: "100%" }}>
//       <div style={{ width: "100%", maxWidth: 700, height: 300 }}>
//         <Radar ref={chartRef} data={chartData} options={chartOptions} />
//       </div>
 
//       {/* Custom Legend */}
//       <div className="custom-legend-grid">
//         {trimmedData.map((item, i) => (
//           <div key={i} className="legend-item">
//             <span className="legend-color-box" />
//             {/* <span className="legend-label">
//               {i + 1}. {item.source} ➜ {item.target}
//             </span> */}
//             <span className="legend-label">
//   {i + 1}. {item.target ? `${item.source} ➜ ${item.target}` : item.source}
// </span>

//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };
 
// export default RadarChartForConversion;





import { useRef } from "react";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const RadarChartForConversion = ({ data = [], height = "300px", width = "100%" }) => {
  const chartRef = useRef(null);
  
  const trimmedData = data;

  // Axis labels as "1" to "8"
  const labels = Array.from({ length: trimmedData.length }, (_, i) =>
    (i + 1).toString()
  );

  // Actual values for the polygon
  const jobCounts = trimmedData.map((item) => item.jobs);

  const datasets = [
    {
      label: "Conversion Jobs",
      data: jobCounts,
      backgroundColor: "rgba(54, 162, 235, 0.2)",
      borderColor: "rgba(54, 162, 235, 1)",
      fill: true,
      borderWidth: 2,
      pointRadius: 3,
    },
  ];

  const chartData = { labels, datasets };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#E0B8FF",
        titleColor: "#212121",
        bodyColor: "#212121",
        callbacks: {
          label: function (context) {
            return `Jobs: ${context.raw}`;
          },
          title: function (context) {
            const index = context[0].dataIndex;
            const item = trimmedData[index];
            return item.target
              ? `${item.source} ➜ ${item.target}`
              : `${item.source}`;
          },
        },
      },
    },
    scales: {
      r: {
        angleLines: { color: "#ddd" },
        grid: { color: "#eee" },
        suggestedMin: 0,
        suggestedMax: Math.max(...jobCounts) + 10,
        ticks: { display: false },
        pointLabels: {
          font: { size: 10 },
          color: "#333",
        },
      },
    },
  };

  return (
    <div className="radar-chart-wrapper" style={{ width: "100%", height: "88%" }}>
      {/* Chart Container - Now responsive */}
      <div style={{ 
        width: "100%", 
        height: height === "auto" ? "400px" : height,
        flex: "1 1 auto",
        minHeight: "300px"
      }}>
        <Radar ref={chartRef} data={chartData} options={chartOptions} />
      </div>

      {/* Custom Legend */}
      <div className="custom-legend-grid">
        {trimmedData.map((item, i) => (
          <div key={i} className="legend-item">
            <span className="legend-color-box" />
            {/* <span className="legend-label">
              {i + 1}. {item.source} ➜ {item.target}
            </span> */}
            <span className="legend-label">
  {i + 1}. {item.target ? `${item.source} ➜ ${item.target}` : item.source}
</span>

          </div>
        ))}
        </div>
    </div>
  );
};

export default RadarChartForConversion;